import * as THREE from 'three';
import Experience from '../../Experience';
import vertexShader from './Shader/vertex.glsl';
import fragmentShader from './Shader/fragment.glsl';
import { gsap } from 'gsap';


export default class StarrySky {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.quality = this.experience.quality;
    this.debug = this.experience.debug;

    this.starDensity = 120;
    this.twinkleSpeed = 3;
    this.brightness = 1
    this.performanceTime = 0;

    /* NOTE: 以前は time.on('tick') と World.update() の両方から update() が呼ばれ、
       回転が1フレームに2回進んでいた。World.update() 駆動に一本化したため、
       見た目の速度を保つように rotationSpeed は 0.01 → 0.02 に調整済み */
    this.rotationSpeed = 0.02; // 星の回転速度
    this.isRotating = false;   // 星の回転を制御するフラグ

    this.createStarrySky();
    this.setDebug();

    //TODO: タイミングなどは最後に調整する
    gsap.delayedCall(7.0, () => {
      this.toggleRotation();
    });
  }

  createStarrySky() {
    const geometry = new THREE.SphereGeometry(27, 32, 32);
    this.material = new THREE.ShaderMaterial({
      // wireframe: true,
      side: THREE.BackSide,
      transparent: true,
      depthWrite: false, // 背景なので深度は書かない（手前の加算パーティクルとのソート問題を防ぐ）
      uniforms: {
        uTime: { value: new THREE.Uniform(0) }, // Time in seconds
        uStarDensity : { value: this.starDensity },   // Density of stars : 球体を分割する数
        uTwinkleSpeed: { value: this.twinkleSpeed },
        uBrightness: { value: this.brightness },
        uPattern: { value: 1.0 },
        uTint: { value: new THREE.Color(1.0, 1.0, 1.0) },
        uTwinkleAmount: { value: 0.35 },
        uNebulaIntensity: { value: this.quality.tier === 'low' ? 0.04 : 0.06 },
      },
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
      blending: THREE.AdditiveBlending
    });

    this.mesh = new THREE.Mesh(geometry, this.material);
    this.mesh.renderOrder = -1; // 常に最初に描く背景
    this.scene.add(this.mesh);

    this.mesh.position.set(0, 0, 0);
  }

  setDebug() {
    if (!this.debug.active) return;

    this.debugFolder = this.debug.ui.addFolder('Starry Sky');
    this.debugFolder.add(this.material.uniforms.uBrightness, 'value')
      .min(0).max(3).step(0.01).name('Brightness');
    this.debugFolder.add(this.material.uniforms.uTwinkleSpeed, 'value')
      .min(0).max(10).step(0.1).name('Twinkle Speed');
    this.debugFolder.add(this.material.uniforms.uTwinkleAmount, 'value')
      .min(0).max(1).step(0.01).name('Twinkle Amount');
    this.debugFolder.add(this.material.uniforms.uNebulaIntensity, 'value')
      .min(0).max(0.5).step(0.005).name('Nebula Intensity');
    this.debugFolder.addColor(this.material.uniforms.uTint, 'value').name('Tint');
    this.debugFolder.add(this, 'isRotating').name('Rotating').listen();
    this.debugFolder.close();
  }

  update() {
    this.performanceTime = performance.now() * 0.001;
    this.material.uniforms.uTime.value = this.performanceTime;

    // 星の回転（reduced-motion 時は大きな流れを止める）
    if (this.isRotating && !this.quality.reducedMotion) {
      this.mesh.rotation.y += this.rotationSpeed * this.time.delta * 0.001;
    }
  }

  toggleRotation() {
    this.isRotating = !this.isRotating;
  }


  // 方法1: SphereGeometry のパラメータで半球作成（最も簡単）
  createHemisphereWithSphere() {
    // phiStart: 0 (開始角度)
    // phiLength: Math.PI (180度 = 半球)
    return new THREE.SphereGeometry(
      20,           // radius
      64,           // widthSegments (経度方向の分割)
      32,           // heightSegments (緯度方向の分割)
      0,            // phiStart (経度の開始角度)
      Math.PI * 2,  // phiLength (経度の範囲 = 360度)
      0,            // thetaStart (緯度の開始角度 = 北極から)
      Math.PI / 2   // thetaLength (緯度の範囲 = 90度 = 半球)
    );
  }
}
